export class getDevice {
    _id:string;
    name: string;
    displayName: string;
    }